module.exports = __webpack_public_path__ + "static/media/temp_5.da55a84f.jpg";